import { CustomSpinner } from '../CustomSpinner'
import { LoadingText, LoadingView } from './styles'

export function ContentLoading({
  isLoading,
  loadingText = 'Carregando...',
  loadingColor,
  children,
}) {
  return (
    <>
      {isLoading ? (
        <LoadingView>
          <CustomSpinner
            size={40}
            color={loadingColor}
          />

          <LoadingText>{loadingText}</LoadingText>
        </LoadingView>
      ) : (
        children
      )}
    </>
  )
}
